import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import { type Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { format, parseISO } from "date-fns";
import { Card } from "@rumbledirect/ui";

interface FleetRecordCardProps {
  dossier: Dossier | undefined;
  isLoading?: boolean;
}

export const FleetRecordCard = ({
  dossier,
  isLoading,
}: FleetRecordCardProps) => {
  const fleetRecord = dossier?.fleetRecord;

  if (!fleetRecord) return null;

  const items: DescriptionsProps["items"] = [
    {
      label: "Lease label",
      children: fleetRecord.fleetLeaseLabel?.displayName ?? null,
    },
    {
      label: "Klant",
      children: fleetRecord.fleetClient?.displayName ?? null,
    },
    {
      label: "Externe referentie",
      children: fleetRecord.fleetClient?.externalReference ?? null,
    },
    {
      label: "Einddatum leasecontract",
      children: fleetRecord.leaseContractEndAt
        ? format(parseISO(fleetRecord.leaseContractEndAt), "dd-MM-yyyy")
        : null,
    },
    {
      label: "Extern verzekerd",
      children:
        fleetRecord.externalInsured != null
          ? fleetRecord.externalInsured
            ? "Ja"
            : "Nee"
          : null,
    },
  ];

  return (
    <Card loading={isLoading} className="w-full" title="Contractinformatie">
      <Descriptions items={items} />
    </Card>
  );
};
